import { Table } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'

import { PaginationMeta } from '../../models/pagination'

import { renderFormatMessage } from '../../helpers/intl'

interface FirmwareHistory {
  count: number
  timestamp: string
  serialNumber: string
  firmwareVersion: string
}

const columns = [
  {
    title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.count', 'Count'),
    key: 'count',
    dataIndex: 'count',
    render: (count: number) => count,
  },
  {
    title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.timestamp', 'Timestamp'),
    key: 'createdAt',
    dataIndex: 'timestamp',
    render: (timestamp: string) => moment(timestamp).format('YYYY-MM-DD - HH:mm:ss'),
  },
  {
    title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.serialNumber', 'Charger Serial Number'),
    key: 'serialNumber',
    dataIndex: 'serialNumber',
    render: (serialNumber: string) => serialNumber,
  },
  {
    title: renderFormatMessage('dashboard.chargerPage.firmwareHistoryTab.firmwareVersion', 'Firmware Version'),
    key: 'firmwareVersion',
    dataIndex: 'firmwareVersion',
    render: (firmwareVersion: string) => firmwareVersion,
  },
]
export const ChargerTabFirmwareVersion: React.FC = () => {
  const [firmwareHistory, setFirmwareHistory] = useState<FirmwareHistory[]>([])
  const [pagination, setPagination] = useState<PaginationMeta>({
    currentPage: 1,
    perPage: 10,
    totalEntries: 3,
  })
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    setFirmwareHistory([
      {
        count: 4,
        timestamp: '2025-07-28T15:25:27.000Z',
        serialNumber: 'AXLU191001W1S1C2319A176A0',
        firmwareVersion: 'V0.78.M0.1191.S1',
      },
      {
        count: 3,
        timestamp: '2025-01-13T19:12:36.000Z',
        serialNumber: 'AXLU191001W1S1C2319A176A0',
        firmwareVersion: 'V0.72.M0.1191.S1',
      },
      {
        count: 2,
        timestamp: '2024-05-04T13:43:11.000Z',
        serialNumber: 'AXLU191001W1S1C2319A176A0',
        firmwareVersion: 'V0.66.M0.1191.S1',
      },
      {
        count: 1,
        timestamp: '2023-11-22T21:21:12.000Z',
        serialNumber: 'AXLU191001W1S1C2319A176A0',
        firmwareVersion: 'V0.64.M0.1191.S1',
      },
    ])
    setPagination({
      currentPage: 1,
      perPage: 10,
      totalEntries: 3,
    })
    setLoading(false)
  }, [])

  const onPaginationChange = (page: number, pageSize?: number) => {
    //setCurrentPage(page)
  }

  return (
    <>
      {/* <AlertError error={error} /> */}
      <Table
        size="small"
        columns={columns}
        dataSource={firmwareHistory}
        loading={loading}
        pagination={{
          position: ['bottomCenter'],
          total: pagination?.totalEntries,
          current: pagination?.currentPage,
          pageSize: pagination?.perPage,
          showSizeChanger: false,
          onChange: onPaginationChange,
        }}
        rowKey={(firmwareHistory: FirmwareHistory): string =>
          `${firmwareHistory.timestamp}-${firmwareHistory.serialNumber}-${firmwareHistory.firmwareVersion}`
        }
      />
    </>
  )
}
